import React from 'react';
import ReactDOM from 'react-dom/client';
import { persistor, store } from './redux/store ';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import { PersistGate } from 'redux-persist/integration/react';
// import axios from 'axios';

// axios.defaults.//withCredentials = true;
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
